const STORAGE_PREFIX = "purchase_tracked_";

/**
 * Guards conversion pixel firing against duplicate reports for the same transaction
 * (e.g. reloading a payment callback page re-derives the same "paid" state).
 * Returns false (and marks it tracked) the first time a transactionId is seen, true after.
 */
export const wasPurchaseAlreadyTracked = (transactionId?: string | null): boolean => {
	if (!transactionId) return false;

	try {
		const key = `${STORAGE_PREFIX}${transactionId}`;
		if (localStorage.getItem(key)) return true;
		localStorage.setItem(key, "1");
		return false;
	} catch {
		return false;
	}
};
